'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { PAGAMENTO_POLLING_BACKOFF_FATOR, PAGAMENTO_POLLING_INTERVALO_MAX_MS, PAGAMENTO_POLLING_INTERVALO_MS, PAGAMENTO_POLLING_TETO_MS } from '@/shared/constants/pagamentoPolling';
import { proximoIntervaloComBackoff } from '@/shared/utils/proximoIntervaloComBackoff';
import { consultarPagamentoSelf, marcarPollingPagamentoExpirado, selectSelfInvoiceUrl, selectSelfPagamentoStatus, selectSelfPollingPagamentoExpirado, selectSelfStep } from '../store';
import type { AbortableThunk } from '../types';
export const usePagamentoSelfPolling = () => {
  const $ = _c(4);
  const dispatch = useAppDispatch();
  const step = useAppSelector(selectSelfStep);
  const pagamentoStatus = useAppSelector(selectSelfPagamentoStatus);
  const invoiceUrl = useAppSelector(selectSelfInvoiceUrl);
  const pollingExpirado = useAppSelector(selectSelfPollingPagamentoExpirado);
  const ativo = step === "pagamento" && pagamentoStatus === "aguardando" && Boolean(invoiceUrl) && !pollingExpirado;
  let t0;
  let t1;
  if ($[0] !== ativo || $[1] !== dispatch) {
    t0 = () => {
      if (!ativo) {
        return;
      }
      let intervalo = PAGAMENTO_POLLING_INTERVALO_MS;
      let decorrido = 0;
      let cancelado = false;
      let agendamento;
      let emVoo = null;
      const agendarProximaRodada = () => {
        agendamento = setTimeout(() => {
          decorrido = decorrido + intervalo;
          decorrido;
          if (decorrido > PAGAMENTO_POLLING_TETO_MS) {
            dispatch(marcarPollingPagamentoExpirado());
            return;
          }
          intervalo = proximoIntervaloComBackoff(intervalo, PAGAMENTO_POLLING_BACKOFF_FATOR, PAGAMENTO_POLLING_INTERVALO_MAX_MS);
          rodada();
        }, intervalo);
      };
      const rodada = async () => {
        const consulta = dispatch(consultarPagamentoSelf());
        emVoo = consulta;
        await consulta;
        if (cancelado) {
          return;
        }
        agendarProximaRodada();
      };
      rodada();
      return () => {
        cancelado = true;
        clearTimeout(agendamento);
        emVoo?.abort();
      };
    };
    t1 = [ativo, dispatch];
    $[0] = ativo;
    $[1] = dispatch;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
};